// extracted by mini-css-extract-plugin
export var details = "_lk-0";
export var inspectorPopover = "_lk-1";